var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaveDaysIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "rotate(180 7 7)",
    fill: "#60B0F9",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.67656,
    transform: "rotate(180 7 7)",
    stroke: "url(#paint0_linear_17785_23604)",
    strokeOpacity: 0.3,
    strokeWidth: 0.646875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88662 8.49914L8.88738 8.49981L8.83772 8.55601C8.96315 8.66079 9.03989 8.81249 9.05009 8.97566C9.06004 9.13883 9.00267 9.29894 8.89126 9.41852M8.88662 8.49914C9.02739 8.61712 9.11349 8.78764 9.12495 8.97098L9.12495 8.9711C9.13612 9.15438 9.07184 9.33427 8.9469 9.46882M8.88662 8.49914L7.3779 7.16584M8.88662 8.49914L7.3779 7.16584M8.9469 9.46882C8.94715 9.46853 8.9474 9.46825 8.94764 9.46797L8.89126 9.41852M8.9469 9.46882C8.94664 9.46909 8.94638 9.46937 8.94613 9.46964L8.89126 9.41852M8.9469 9.46882C8.82007 9.61295 8.63734 9.6956 8.44541 9.69569C8.28042 9.69705 8.12061 9.63733 7.99692 9.52799L7.99684 9.52792L6.26601 7.99337L6.31546 7.93698M8.89126 9.41852C8.77857 9.54701 8.61591 9.62069 8.44509 9.62069C8.29849 9.62197 8.15648 9.56894 8.04659 9.4718L6.31546 7.93698M6.31546 7.93698L6.2657 7.9931L6.26587 7.99325M6.31546 7.93698C6.18696 7.82429 6.11328 7.66163 6.11328 7.49081V4.51652C6.11328 4.30415 6.22674 4.10758 6.41056 4.00152C6.59438 3.89546 6.82154 3.8952 7.00562 4.00152C7.1897 4.10783 7.3029 4.30415 7.3029 4.51678V7.19965L6.26587 7.99325M6.26587 7.99325C6.12122 7.86632 6.03828 7.68317 6.03828 7.49081V4.51652C6.03828 4.27737 6.16601 4.05602 6.37308 3.93655C6.58005 3.81713 6.8358 3.81682 7.04313 3.93657C7.25043 4.0563 7.3779 4.27739 7.3779 4.51678V7.16584M6.26587 7.99325L7.3779 7.16584",
    fill: "#8DC8FF",
    stroke: "#8DC8FF",
    strokeWidth: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17785_23604",
    x1: -3.675,
    y1: -20.65,
    x2: 7,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveDaysIcon);
export default __webpack_public_path__ + "static/media/LeaveDaysIcon.13b288acbe10e770d170722349aeb928.svg";
export { ForwardRef as ReactComponent };